import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SuccessStepWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${Spacing.S10};
  justify-content: center;
  width: 100%;
  min-height: 420px;
  padding: ${Spacing.S40} 0;
`

export const SuccessSquircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.Lime100};
`

export const SuccessCopy = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${Spacing.S14};
  width: 100%;
  max-width: 700px;
`
